/**
 * ForetoldEvents.com & Blood Moon Rising Client-Side Scripts
 * Handles: Event Countdowns, UTM Attribution, and Cart Attributes
 */

(function() {
  'use strict';

  // 1. Persist UTM Parameters into sessionStorage and Cart Attributes
  function captureUtmParams() {
    var params = new URLSearchParams(window.location.search);
    var utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'ref', 'user_id'];
    utmKeys.forEach(function(key) {
      if (params.has(key)) {
        try {
          sessionStorage.setItem('bmr_' + key, params.get(key));
        } catch (e) {}
      }
    });

    // Attach to checkout forms
    document.querySelectorAll('.pass-checkout-form').forEach(function(form) {
      utmKeys.forEach(function(key) {
        var val = null;
        try {
          val = sessionStorage.getItem('bmr_' + key) || params.get(key);
        } catch (e) {
          val = params.get(key);
        }
        if (val) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'attributes[' + key + ']';
          input.value = val;
          form.appendChild(input);
        }
      });
    });
  }

  // 2. Dual Countdown Clocks (Sunday October 18, 2026 & Saturday October 24, 2026)
  function initCountdown() {
    var countdownEl = document.getElementById('event-countdown');
    if (!countdownEl) return;

    var oct18Str = countdownEl.getAttribute('data-oct18') || '2026-10-18T16:00:00-06:00';
    var oct24Str = countdownEl.getAttribute('data-oct24') || '2026-10-24T16:00:00-06:00';
    var oct18Target = new Date(oct18Str).getTime();
    var oct24Target = new Date(oct24Str).getTime();

    var daysEl = document.getElementById('days');
    var hoursEl = document.getElementById('hours');
    var minEl = document.getElementById('minutes');
    var secEl = document.getElementById('seconds');

    function update() {
      var now = new Date().getTime();
      var target = now < oct18Target ? oct18Target : oct24Target;
      var diff = target - now;

      if (diff <= 0) {
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minEl) minEl.textContent = '00';
        if (secEl) secEl.textContent = '00';
        return;
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minEl) minEl.textContent = String(minutes).padStart(2, '0');
      if (secEl) secEl.textContent = String(seconds).padStart(2, '0');
    }

    update();
    setInterval(update, 1000);
  }

  document.addEventListener('DOMContentLoaded', function() {
    captureUtmParams();
    initCountdown();
  });
})();
